// extracted by mini-css-extract-plugin
export default {"StepsContainer":"StepsContainer_StepsContainer__9rBtT"};